<template>
  <industry-single>
    <template v-slot:hero
      ><hero-full
        imageName="industries/commercial-real-estate-loans-banner.jpg"
        altText="A background of commercial properties"
        ctaButtonTitle="Check Eligibility"
      >
        <template v-slot:content>
          <h1>Commercial Real Estate Loans</h1>
          <p>Business Loans | Fast Funding</p>
        </template>
      </hero-full></template
    >
    <template v-slot:form-section>
      <FormSection>
        <template v-slot:content>
          <h2>
            <span>American Credit:</span> Empowering businesses everyday with commercial real estate loans.
          </h2>
          <p>
            Whether you’re a developer, investor, or business owner looking to finally purchase  or refinance your property, American Credit can help. We offer commercial property loans for different uses, including purchasing or refinancing  industrial properties & warehouses, retail properties, multi-family properties, and commercial office buildings. We also have a wide variety of custom real estate financing solutions. They range from No-Ratio, Stated Income, Bank Statements Only, Full-Doc, to No-Doc Loans. Besides conventional loans, we also offer bridge loans, fix & flip/ fix & hold, as we as SBA/business loans.
            <br />
            <br />
            Read on and see how we help people just like you receive Commercial Real Estate loans everyday. 
            <br />
          </p>
        </template>
        <template v-slot:logos>
          <div class="row">
            <div class="col-12 col-md-5 order-md-2 d-flex">
              <div class="row logos-brands">
                <div class="col-6 col-md-12">
                  <a
                    href="https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741"
                    target="_blank"
                  >
                    <img
                      src="/static/assets/imgs/industries/bbba-logo.png"
                      alt="BBBA logo"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <img
                src="/static/assets/imgs/industries/google-review.png"
                alt="Google Review"
              />
            </div>
          </div>
        </template>
        <!-- <template v-slot:form>
          <div id="form-script" class="form-script" v-once></div>
        </template> -->
      </FormSection>
    </template>
    <template v-slot:first-row>
      <RowSection
        img-side="left"
        imageName="industries/commercial-real-estate-loans1.jpg"
        altText="A comercial property by the street"
        backgroundPrimary="#00234D"
        backgroundSecondary="#F6F9FE"
        v-bind:displayCtaButton="false"
      >
        <template v-slot:content>
          <h2>Commercial Property Loans</h2>
          <p>
           Utilize your Commercial Construction Loan to purchase the land or commercial property your business needs. Use your Commercial Property Loan to invest in a multi-family unit rental property like an apartment complex, purchase a commercial office building, or renovate your recently purchased commercial property. 
            Moreover, we also provide loans for commercial condos, mixed use, gas stations, and church financing.
            <br />
            <br />
            When it comes to Commercial Real Estate Financing, you have the luxury of utilizing your business loan to best serve your need. Call us to learn more about how we can help you get the Commercial Real Estate financing you need in a hurry.
          </p>
        </template>
      </RowSection>
    </template>
    <template v-slot:second-row>
      <RowSection
        img-side="right"
        imageName="industries/commercial-real-estate-loans2.jpg"
        altText="Commercial properties by the street"
        v-bind:displayCtaButton="false"
      >
        <template v-slot:content>
          <h2>Commercial Real Estate Financing for New Property Construction</h2>
          <p>
            Looking to create a brand new property with your Commercial Construction Loan? For some commercial real estate investors & business owners, building a commercial property from the ground up is a better long-term investment. 
            <br />
            <br />
            Use your Commercial Real Estate loan to finance the construction of your brand new commercial property. Your Commercial Property Loan can finance any needed construction labor & equipment. This loan type is often used for the purchase of immediate supplies & construction equipment, meeting immediate employee payroll, and more. Whatever the need, your Commercial Property Loan can assist you with the overall goal of obtaining your very own commercial property. 
          </p>
        </template>
      </RowSection>
    </template>
    <template v-slot:third-row>
      <IconsGrid :gridElements="gridItems">
        <template v-slot:title>Geared to Your Needs and Your Business</template>
      </IconsGrid>
    </template>
    <template v-slot:fourth-row>
      <TablesSection :tables="tableItems">
        <template v-slot:title>Construction Loan Requirements</template>
        <template v-slot:text
          >Minimum loan requirements to expedite approval & secure quick
          funding.</template
        >
      </TablesSection>
    </template>
    <template v-slot:fifth-row>
      <RowSection
        img-side="right"
        imageName="industries/Lei-li-formal.jpeg"
        altText="photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
        class="lei-section"
      >
        <template v-slot:content>
          <h2><span>American Credit:</span> The Difference You Can Trust</h2>
          <p>
            Your business is not JUST a business. It’s YOURS. It’s your
            livelihood. It’s your passion. American Credit completely
            understands this. We help business owners just like you everyday, by
            taking a wholistic approach to business financing.
            <strong>Dr. Lei Li, PhD, CFA, & CEO of American Credit</strong>, is
            an Economist who uses his 20+ years of industry experience to help
            business owners achieve their American Dream:
            <strong>successful business ownership</strong>. <br /><br />
            Whatever financial situation you’re in, American Credit has your
            back. Apply for your business loan today!
          </p>
        </template>
        <template v-slot:button-contact>
          <contact-info
            imageName="Lei_Li.png"
            altText="Lei's photo"
            title="Call Lei"
            contactType="Service"
            phoneNumber="650-885-8055"
            class="d-none d-md-flex"
          />
        </template>
      </RowSection>
    </template>
    <template v-slot:google-reviews>
      <div class="elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"></div>
    </template>
  </industry-single>
</template>

<script>
import IndustrySingle from "../../components/layouts/IndustrySingle.vue";

import HeroFull from "../../components/industries/HeroFull.vue";
import FormSection from "../../components/industries/FormSection.vue";
import RowSection from "../../components/industries/RowSection.vue";
import IconsGrid from "../../components/industries/IconsGrid.vue";
import TablesSection from "../../components/industries/TablesSection.vue";
import ContactInfo from "../../components/industries/ContactInfo.vue";

export default {
  components: {
    IndustrySingle,
    HeroFull,
    FormSection,
    RowSection,
    IconsGrid,
    TablesSection,
    ContactInfo,
  },
  data() {
    return {
      gridItems: [
        {
          graphic: "coins.svg",
          title: "Rates starting as low as 4.5%",
          text: "Great Fixed-Interest Rates for many industries",
        },
        {
          graphic: "calendar.svg",
          title: "Terms from 12 - 84 months",
          text: "Flexible repayment terms. Choose what works best for your needs.",
        },
        {
          graphic: "cash.svg",
          title: "Loans from $10K - $10M",
          text: "Different loan amounts for business different needs.",
        },
        {
          graphic: "mobile.svg",
          title: "Fully Digital Application",
          text: "Fast & simple online application. Quick approval decision.",
        },
        {
          graphic: "house.svg",
          title: "Possible funding in just 48 hours",
          text: "Once approved, your funds are immediately sent to your bank.",
        },
        {
          graphic: "247.svg",
          title: "Apply anytime 24/7",
          text: "Apply from home anytime. Never drive to a bank again.",
        },
      ],
      tableItems: [
        {
          title: "Conventional",
          rows: [
            {
              title: "Amount",
              value: "$250k - 30M",
            },
            {
              title: "Term",
              value: "5 - 30 Year",
            },
            {
              title: "LTV",
              value: "up to 80%",
            },
            {
              title: "FICO",
              value: "650+",
            }
          ],
        },
        {
          title: "Bridge Loans",
          rows: [
            {
              title: "Amount",
              value: "$150k - 30M",
            },
            {
              title: "Term",
              value: "1 - 4 Year",
            },
            {
              title: "LTV",
              value: "up to 75%",
            },
            {
              title: "FICO",
              value: "No min FICO",
            }
          ],
        },
        {
          title: "Fix & Flip / Fix & Hold",
          rows: [
            {
              title: "Amount",
              value: "$150k - 15M",
            },
            {
              title: "Term",
              value: "1 - 3 Years interest only",
            },
            {
              title: "LTV",
              value: "70 - 90%\nup to 100% Rehab budget",
            },
            {
              title: "FICO",
              value: "650+",
            }
          ],
        },
        {
          title: "SBA / Business Loans",
          rows: [
            {
              title: "Amount",
              value: "$250k - 25M",
            },
            {
              title: "Term",
              value: "5 - 15 Years interest only\n15, 20, 25 year amortization",
            },
            {
              title: "LTV",
              value: "UP TO 90%",
            },
            {
              title: "FICO",
              value: "650+",
            }
          ],
        }
      ],
    };
  },
  computed: {
    hasSecondRow() {
      return this.$slots["second-row"];
    },
  },
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Commercial Real Estate Loans | American Credit";
    meta.content =
      "Use your commercial real estate loan to purchase industrial properties, retail properties, warehouses, multi-family homes, and more. Contact us today!";

    let externalScriptInternetExplorer = document.createElement("script");
    externalScriptInternetExplorer.setAttribute("charset", "utf-8");
    externalScriptInternetExplorer.setAttribute("type", "text/javascript");
    externalScriptInternetExplorer.setAttribute(
      "src",
      "//js.hsforms.net/forms/v2-legacy.js"
    );
    document
      .getElementById("form-script")
      .appendChild(externalScriptInternetExplorer);

    let externalScript = document.createElement("script");
    externalScript.setAttribute("charset", "utf-8");
    externalScript.setAttribute("type", "text/javascript");
    externalScript.setAttribute("src", "//js.hsforms.net/forms/v2.js");
    document.getElementById("form-script").appendChild(externalScript);

    const formData = {
      region: "na1",
      portalId: "8349954",
      formId: "465a5b2f-3e31-414f-9f02-66349b102c60",
      target: "#form-script",
    };

    externalScript.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create(formData);
      }
    });

    externalScriptInternetExplorer.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create(formData);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .logos-brands {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// commercialRealEstateLoans.vue?01b447a0